import { render, staticRenderFns } from "./ActPay.vue?vue&type=template&id=5ad904b8&scoped=true"
import script from "./ActPay.vue?vue&type=script&lang=js"
export * from "./ActPay.vue?vue&type=script&lang=js"
import style0 from "./ActPay.vue?vue&type=style&index=0&id=5ad904b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad904b8",
  null
  
)

export default component.exports